import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { ReactComponent as List } from '../../assets/svgs/list.svg'
import { baseLayout } from '../../constants/theme'

export const AppHeader = styled('header')(({ theme, collapsed, locale }) => ({
  position: 'fixed',
  top: '0',
  right: '0',
  left: collapsed ? baseLayout.sidebarCollapsedWidth : baseLayout.sidebarWidth,
  zIndex: '1002',
  backgroundColor: theme.header,
  boxShadow: `0px 10px 20px ${theme.boxShadow}`,

  '@media (max-width: 992px)': {
    left: baseLayout.sidebarCollapsedWidth,
  },
  ...(locale === 'ar' && {
    left: '0',
    right: collapsed
      ? baseLayout.sidebarCollapsedWidth
      : baseLayout.sidebarWidth,
  }),
}))

export const Navbar = styled('nav')(() => ({
  display: 'flex',
  flexPack: 'justify',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '0 auto',
  height: baseLayout.headerHeight,
  padding: `0 calc(${baseLayout.gridGutterWidth} / 2) 0 0`,
}))

export const NavBarBrandBox = styled('div')(({ collapsed, theme }) => ({
  textAlign: 'center',
  width: collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  height: baseLayout.headerHeight,
  background: theme.logoNav,
  transition: 'width 0.2s ease',
  position: 'fixed',
  top: '0px',
  zIndex: 99,
  '@media (max-width: 992px)': {
    width: `${baseLayout.sidebarCollapsedWidth} !important`,
  },
}))

export const LogoNav = styled(Link)(({ collapsed, theme }) => ({
  lineHeight: baseLayout.headerHeight,
  backgroundColor: theme.logoNav,
  width: collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  display: 'flex',
  justifyContent: 'center',
  '@media (max-width: 992px)': {
    width: `${baseLayout.sidebarCollapsedWidth} !important`,
  },
}))

export const Logo = styled('span')(({ collapsed, locale, theme }) => ({
  width: collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  padding: '0px',
  margin: '0px',
  marginLeft: collapsed ? '0' : '70px',
  '@media (max-width: 992px)': {
    display: 'none',
  },
  ...(locale === 'ar' && {
    marginLeft: '0px',
    marginRight: collapsed ? '0' : '70px',
    width: collapsed
      ? `${baseLayout.sidebarCollapsedWidth} !important`
      : '70px',
  }),
   backgroundColor: theme.white ,
}))

export const LogoSmall = styled('p')({
  padding: '0px',
  margin: '0px',
  '@media (min-width: 992px)': {
    display: 'none',
  },
})

export const HeaderItem = styled('button')(({ theme }) => ({
  height: baseLayout.headerHeight,
  boxShadow: 'none !important',
  color: theme.headerItemColor,
  backgroundColor: 'transparent',
  border: '0',
  borderRadius: '0px',
  position: 'relative',
  '&:hover': {
    color: theme.headerItemColorHover,
  },
}))

export const HeaderBtn = styled(List)(({ theme }) => ({
  background: 'transparent',
  color: theme.collapseSidebarBtn,
  fontSize: '1.5rem',
  cursor: 'pointer',
  '&:hover': {
    color: theme.headerItemColorHover,
  },
}))

export const LogoImg = styled('img')(({ theme }) => ({
  position: 'absolute',
  marginLeft:'0px' ,
  left: '17.46%',
  right: '25.79%',
  top: '17.14%',
  bottom: '27.14%',
}))
